<div class="modal-header">
  <h4 class="modal-title">{{ documentName }} Unavailable</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  <p>The {{ documentName.toLowerCase() }} for this project are currently unavailable.</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="close()">OK</button>
</div>
